module.exports = __webpack_public_path__ + "e5d2c243516e806437cce496928b4d16.png";